import { C } from "../lib/colors.js";
import { Spinner } from "./ui/Primitives.jsx";

/**
 * The one inline loading treatment: the shared spinner beside a short sentence-case line
 * ending in "…" ("Restoring your forecasts…"). Use instead of pulsing words or animated dots.
 */
export default function LoadingLine({ children, size = "md", style }) {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        fontSize: 13,
        color: C.gray,
        ...style,
      }}
    >
      <Spinner size={size} label={typeof children === "string" ? children : "Loading"} />
      {children}
    </span>
  );
}
